import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instancep7dfbo63nk35 as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.a4h_1 = 8192;
        this.b4h_1 = 1024;
      }
      c4h() {
        return Segment().d4h();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.b4f_1 = 0;
  _this__u8e3s4.c4f_1 = 0;
  _this__u8e3s4.d4f_1 = null;
  _this__u8e3s4.e4f_1 = false;
  _this__u8e3s4.f4f_1 = null;
  _this__u8e3s4.g4f_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      f4g() {
        var tmp0_safe_receiver = this.d4f_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e4h();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static d4h() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.a4f_1 = new Int8Array(8192);
        $this.e4f_1 = true;
        $this.d4f_1 = null;
        return $this;
      }
      static f4h(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.a4f_1 = data;
        $this.b4f_1 = pos;
        $this.c4f_1 = limit;
        $this.d4f_1 = shareToken;
        $this.e4f_1 = owner;
        return $this;
      }
      n4f() {
        var tmp0_elvis_lhs = this.d4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.g4h();
          this.d4f_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.b4f_1;
        var tmp_1 = this.c4f_1;
        // Inline function 'kotlin.also' call
        t.h4h();
        return Segment().f4h(this.a4f_1, tmp_0, tmp_1, t, false);
      }
      i4g() {
        var result = this.f4f_1;
        if (!(this.g4f_1 == null)) {
          ensureNotNull(this.g4f_1).f4f_1 = this.f4f_1;
        }
        if (!(this.f4f_1 == null)) {
          ensureNotNull(this.f4f_1).g4f_1 = this.g4f_1;
        }
        this.f4f_1 = null;
        this.g4f_1 = null;
        return result;
      }
      o4f(segment) {
        segment.g4f_1 = this;
        segment.f4f_1 = this.f4f_1;
        if (!(this.f4f_1 == null)) {
          ensureNotNull(this.f4f_1).g4f_1 = segment;
        }
        this.f4f_1 = segment;
        return segment;
      }
      g4g(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.c4f_1 - this.b4f_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.n4f();
        } else {
          prefix = SegmentPool_instance.o3w();
          var tmp0 = this.a4f_1;
          var tmp2 = prefix.a4f_1;
          var tmp5 = this.b4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.b4f_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.c4f_1 = prefix.b4f_1 + byteCount | 0;
        this.b4f_1 = this.b4f_1 + byteCount | 0;
        if (!(this.g4f_1 == null)) {
          ensureNotNull(this.g4f_1).o4f(prefix);
        } else {
          prefix.f4f_1 = this;
          this.g4f_1 = prefix;
        }
        return prefix;
      }
      p4f() {
        // Inline function 'kotlin.check' call
        if (!!(this.g4f_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.g4f_1).e4f_1)
          return this;
        var byteCount = this.c4f_1 - this.b4f_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.g4f_1).c4f_1 | 0) + (ensureNotNull(this.g4f_1).f4g() ? 0 : ensureNotNull(this.g4f_1).b4f_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.g4f_1;
        this.h4g(ensureNotNull(predecessor), byteCount);
        var successor = this.i4g();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.p4g(this);
        return predecessor;
      }
      l4g(byte) {
        var _unary__edvuaz = this.c4f_1;
        this.c4f_1 = _unary__edvuaz + 1 | 0;
        this.a4f_1[_unary__edvuaz] = byte;
      }
      n4g(short) {
        var data = this.a4f_1;
        var limit = this.c4f_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.c4f_1 = limit;
      }
      i4f() {
        var _unary__edvuaz = this.b4f_1;
        this.b4f_1 = _unary__edvuaz + 1 | 0;
        return this.a4f_1[_unary__edvuaz];
      }
      k4f() {
        var data = this.a4f_1;
        var pos = this.b4f_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.b4f_1 = pos;
        return s;
      }
      h4g(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.e4f_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.c4f_1 + byteCount | 0) > 8192) {
          if (sink.f4g())
            throw IllegalArgumentException().xd();
          if (((sink.c4f_1 + byteCount | 0) - sink.b4f_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.a4f_1;
          var tmp2 = sink.a4f_1;
          var tmp5 = sink.b4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.c4f_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.c4f_1 = sink.c4f_1 - sink.b4f_1 | 0;
          sink.b4f_1 = 0;
        }
        var tmp0_0 = this.a4f_1;
        var tmp2_0 = sink.a4f_1;
        var tmp4 = sink.c4f_1;
        var tmp6 = this.b4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.b4f_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.c4f_1 = sink.c4f_1 + byteCount | 0;
        this.b4f_1 = this.b4f_1 + byteCount | 0;
      }
      t4f(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.a4f_1;
        var tmp6 = this.b4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.b4f_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.b4f_1 = this.b4f_1 + len | 0;
      }
      d4g(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.a4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.c4f_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.c4f_1 = this.c4f_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      v2() {
        return this.c4f_1 - this.b4f_1 | 0;
      }
      c4g() {
        return this.a4f_1.length - this.c4f_1 | 0;
      }
      i4h(readOnly) {
        return this.a4f_1;
      }
      r4f(index) {
        return this.a4f_1[this.b4f_1 + index | 0];
      }
      j4h(index, value) {
        this.a4f_1[this.c4f_1 + index | 0] = value;
      }
      k4h(index, b0, b1) {
        var d = this.a4f_1;
        var l = this.c4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      l4h(index, b0, b1, b2) {
        var d = this.a4f_1;
        var l = this.c4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      m4h(index, b0, b1, b2, b3) {
        var d = this.a4f_1;
        var l = this.c4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.v2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      e4h() {
        return true;
      }
      h4h() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.v2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().s2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.v2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().s2(toString(message_0));
  }
  var p = _this__u8e3s4.b4f_1;
  var data = _this__u8e3s4.i4h(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance35mam6kufibag,
  Companion_instance as Companion_instance1evlhu73xfb8l,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
